module.exports = __webpack_public_path__ + "media/images/ratrustvox-logo-6c5a30ac042a79c3956ecbc076175fc4.svg";